import React from 'react';
import MaterialTable from 'material-table';
import { darken } from '@material-ui/core';
import { useSelector } from 'react-redux';

import { COLORS_PROJECT } from '../../constants';


const {color_nav_letter_enc_table,color_enc_table,color_background_tables}= COLORS_PROJECT; // color_nav,color_nav_letter,

export const ReportStormTable = () => {
    const {data} = useSelector(state => state.print);
    const {6:dayStrom}= data;
    let days;
    if(dayStrom===undefined){
        days = 0
    }else{
        days = dayStrom.dias_tormenta
    }
     

    return (
        <>
            <MaterialTable
                columns = {[
                    {field: 'parametro', title: 'Parámetro de la tormenta'},
                    {field: 'valor', title: 'Valor'},
                ]}
                data={[
                    {parametro:'Días de tormenta',valor: days},
                    
                ]}

                options={{
                    paging: false,
                    search: false,
                    showTitle: false,
                    toolbar: false,
                    headerStyle: {
                        backgroundColor: darken(color_enc_table,0.2),
                        color: color_nav_letter_enc_table,
                        fontWeight: 'bold',
                    },
                    rowStyle: {backgroundColor: color_background_tables},
                }}
            /> 
        </>
    )
}
